import React, { useEffect } from 'react';
import Navbar from '../Shared/Navbar/Navbar';
import Footer from '../Shared/Footer/Footer';
import Aos from 'aos';
import emailjs from 'emailjs-com';

const ContactMe = () => {
    useEffect(() => {
        Aos.init({ duration: 1500 });
    }, []);

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('gmail', 'template_xd42atp', e.target, 'user_2x3Ql2qTnv7wocannrGlz')
            .then((result) => {
                console.log(result);
            }, (error) => {
                console.log(error.text);
            });
        e.target.reset()
    }
    return (
        <section className="container">
            <div>
                <Navbar></Navbar>
            </div>
            <div data-aos="fade-down" className="pt-5 text-center lh-base text-white">
                <p>Thanks for visiting my site 😊</p>
                <h2>Get In Touch</h2>
                <h5>If you have any query, feel free to ask me. Be connected with me.</h5>
            </div>
            <div data-aos="fade-up" className="my-5 pt-5">
                <div className="container col-md-8 col-12 bg-dark rounded p-5">
                    <div className="section-header text-center text-white mb-5">
                        <h3>Say Something</h3>
                    </div>
                    <div className="col-md-9 mx-auto">
                        <form onSubmit={sendEmail}>
                            <div className="form-group">
                                <input type="text" className="form-control mb-3" placeholder="Your Name" name="name" />
                            </div>
                            <div className="form-group">
                                <input type="text" className="form-control mb-3" placeholder="Your Email" name="email" />
                            </div>
                            <div className="form-group">
                                <textarea className="form-control mb-3" id="" cols="30" rows="10" placeholder="Your Message" name="message" ></textarea>
                            </div>
                            <div className="form-group text-center">
                                <button type="submit" className="btn btn-primary"> Send </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div>
                <Footer></Footer>
            </div>
        </section>
    );
};

export default ContactMe;